import React from "react";
import { Link } from "react-router-dom";
import { OUTBOUND_URL } from "../data/characters";

const Header = () => {
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-40 bg-white/85 backdrop-blur border-b-2 border-black"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 h-16 flex items-center justify-between">
        <Link
          data-testid="header-logo"
          to="/"
          className="font-display font-black uppercase tracking-tighter text-lg sm:text-xl"
        >
          Character<span className="text-[#FF2D55]">.</span>AI<span className="text-[#00E5FF]">.</span>Chat
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-bold uppercase tracking-[0.18em] font-body">
          <a href="/#characters" className="hover:text-[#FF2D55] transition" data-testid="nav-characters">
            Characters
          </a>
          <a href="/#features" className="hover:text-[#FF2D55] transition" data-testid="nav-features">
            Features
          </a>
          <a href="/#how-it-works" className="hover:text-[#FF2D55] transition" data-testid="nav-how">
            How
          </a>
          <a href="/#faq" className="hover:text-[#FF2D55] transition" data-testid="nav-faq">
            FAQ
          </a>
        </nav>

        <a
          data-testid="header-cta"
          href={OUTBOUND_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-black text-white font-display font-black uppercase tracking-tight text-xs sm:text-sm px-4 sm:px-5 py-2.5 border-2 border-black hover:bg-[#FF2D55] hover:border-[#FF2D55] transition"
        >
          Chat now →
        </a>
      </div>
    </header>
  );
};

export default Header;
